export const size = {
  /**
   * 0.0625rem / 1px
   */
  0: "0.0625rem",
  /**
   * 0.125rem / 2px
   */
  0.5: "0.125rem",
  /**
   * 0.25rem / 4px
   */
  1: "0.25rem",
  /**
   * 0.5rem / 8px
   */
  2: "0.5rem",
  /**
   * 0.75rem / 12px
   */
  3: "0.75rem",
  /**
   * 1rem / 16px
   */
  4: "1rem",
  /**
   * 1.25rem / 20px
   */
  5: "1.25rem",
  /**
   * 1.5rem / 24px
   */
  6: "1.5rem",
  /**
   * 1.75rem / 28px
   */
  7: "1.75rem",
  /**
   * 2rem / 32px
   */
  8: "2rem",
  /**
   * 2.5rem / 40px
   */
  10: "2.5rem",
  /**
   * 3rem / 48px
   */
  12: "3rem",
  /**
   * 4rem / 64px
   */
  16: "4rem",
  /**
   * 5rem / 80px
   */
  20: "5rem",
  /**
   * 6rem / 96px
   */
  24: "6rem",
  /**
   * 7rem / 112px
   */
  28: "7rem",
  /**
   * 8rem / 128px
   */
  32: "8rem",
  /**
   * 10rem / 160px
   */
  40: "10rem",
  /**
   * 12rem / 192px
   */
  48: "12rem",
  /**
   * 14rem / 224px
   */
  56: "14rem",
  /**
   * 16rem / 256px
   */
  64: "16rem",
  /**
   * 18rem / 288px
   */
  72: "18rem",
  /**
   * 20rem / 320px
   */
  80: "20rem",
  /**
   * 22rem / 352px
   */
  88: "22rem",
  /**
   * 26rem / 416px
   */
  104: "26rem",
} as const;

export const sizePx = {
  0: 1,
  0.5: 2,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  7: 28,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
  20: 80,
  24: 96,
  28: 112,
  32: 128,
  40: 160,
  48: 192,
  56: 224,
  64: 256,
  72: 288,
  80: 320,
  88: 352,
  104: 416,
} as const;
